/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconSpace = createReactComponent("space", "IconSpace", [
  ["path", { d: "M4 10v3a1 1 0 0 0 1 1h14a1 1 0 0 0 1 -1v-3", key: "svg-0" }]
]);

export { IconSpace as default };
//# sourceMappingURL=IconSpace.js.map
